import { useState } from 'react'

import { useStoreAnalytics } from '@/hooks/features/analytics'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

import { BrowsingCard } from '../AnalyticsCards'
import { titleClass } from '../constants'
import { ProductsTable, type AnalyticsFilters } from '../parts'

import type { AnalyticsPages, AnalyticsProductRow } from '@/types/analytics'

type ProductSort = 'views' | 'opportunity' | 'add_rate' | 'purchases'

/** Which products get attention and which do not turn into add-to-carts, plus how shoppers search and filter. */
export const ProductsTab = ({ range, filters }: { range: AnalyticsFilters; filters: AnalyticsFilters }) => {
  const [sort, setSort] = useState<ProductSort>('views')
  const products = useStoreAnalytics<AnalyticsProductRow[]>('products', { ...range, sort, limit: 15 })
  const pages = useStoreAnalytics<AnalyticsPages>('pages', filters)

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-3 space-y-0">
          <CardTitle className={titleClass}>Products</CardTitle>
          <Tabs value={sort} onValueChange={(v) => setSort(v as ProductSort)}>
            <TabsList>
              <TabsTrigger value="views">Most viewed</TabsTrigger>
              <TabsTrigger value="opportunity">Viewed, not added</TabsTrigger>
              <TabsTrigger value="add_rate">Best add rate</TabsTrigger>
              <TabsTrigger value="purchases">Most ordered</TabsTrigger>
            </TabsList>
          </Tabs>
        </CardHeader>
        <CardContent>
          <ProductsTable q={products} />
        </CardContent>
      </Card>

      <BrowsingCard q={pages} />
    </div>
  )
}
